import Textarea from "@/components/common/Textarea.vue";
import TextField from "@/components/common/text-field/TextField.vue";
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import message from "@/components/common/message/Message.vue";

const defaultEl = {
    ContactPersonId: null,
    client_id: null,
    first_name: null,
    last_name: null,
    phone: null,
    email: null,
    comment: null
}

const phoneRegex = /^\+[0-9]{6,24}$/
const phoneValidator = helpers.withMessage(
    '',
    value => phoneRegex.test(value)
)

export default {
    name: 'ModalContact',

    components: {
        message,
        TextField,
        Textarea
    },

    setup: () => ({ v$: useVuelidate() }),
    data () {
        return {
            form: defaultEl,
            message: null,
            loading: false,
            isVisibleMsg: false,
            msg: null,
            isMsg: null
        }
    },

    validations () {
        return {
            form: {
                first_name: { required },
                phone: { required, phoneValidator },
                email: { email }
            }
        }
    },

    methods: {
        show (contact, message) {
            this.v$.$reset();
            if (contact.ContactPersonId) {
                this.form = this.BasicHelper.cloneObject(contact);
            } else {
                this.form = this.BasicHelper.cloneObject(defaultEl);
                this.form.client_id = contact.client_id;
            }

            this.message = message;
            this.$refs['modal-window'].show();
        },

        async submit () {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                return;
            }
            this.loading = true;
            try {
                const { data } = await this.store();
                if (data) {
                    if (data.duplicate) {
                        this.isVisibleMsg = true;
                        this.isMsg = 'danger';
                        this.msg = this.$t('client.duplicate');
                    }

                    if (data.success) {
                        this.$emit('onStore');
                        this.$refs['modal-window'].hide();
                    }
                }
            } finally {
                this.loading = false;
            }
        },

        async store() {
            return this.ApiRequest.requestAsync(
                `company/contacts/store`,
                this.ApiRequest.REQUEST_PUT,
                { 'form': this.form },
                'company-contacts-store',
                true
            );
        },

        changeIsVisibleMsg(isVisible) {
            this.isVisibleMsg = isVisible;
        },

        close () {
            this.$refs['modal-window'].hide();
        }
    }
}